import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooCouponGuidePage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-coupon-guide')!;
  return <ArticleLayout article={article} />;
}